// utils/pagination.js
// Shared pagination-aware S.NO. helper for Admin list tables. Never
// persisted, never sent to the API, never used as a row key -- purely a
// display-time row index derived from the current page/pageSize. Keep
// row.id as the real identifier for Edit/Delete/View actions and React
// `key` props.
export function getSerialNumber(index, page = 1, pageSize = 10) {
  const safePage = Math.max(Number(page) || 1, 1);
  const safePageSize = Math.max(Number(pageSize) || 10, 1);

  return (safePage - 1) * safePageSize + index + 1;
}
